export function clone(object) {
  return Object.assign({}, object)
}

export default {
  clone,
}
